import { HTMLAttributes } from 'react';
import { StepperStatus } from '../../enums';
import { Badge } from './Badge';
import styles from './styles.module.scss';

export type StepDisplayProps = HTMLAttributes<HTMLDivElement> & {
  label: string;
  status: StepperStatus;
  stepNumber: number;
};

export const StepDisplay = ({ label, status, stepNumber }: StepDisplayProps) => (
  <>
    <Badge stepNumber={stepNumber} status={status} />
    <span className={styles.stepperItemLabel}>{label}</span>
  </>
);
